const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "TShirt",
    transform: "matrix(0.173598,0,0,0.220789,1.33235,1.73089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.228,0.277C29.85,0.434 0.394,19.651 0.015,19.996C-0.237,20.246 14.965,42.729 15.31,42.603C15.531,42.54 18.59,40.719 22.154,38.552L28.651,34.658L28.651,92.998L94.25,92.998L94.25,63.953C94.25,47.971 94.344,34.908 94.44,34.908C94.566,34.908 97.625,36.698 101.251,38.864C104.879,41.062 107.874,42.789 107.938,42.726C108.348,42.286 122.981,20.056 122.888,19.993C122.824,19.962 116.044,15.472 107.812,10.071L92.832,0.212L83.497,0.12L74.161,0.024L73.341,1.28C70.629,5.362 66.466,7.622 61.578,7.653C56.878,7.685 52.81,5.706 50.098,1.97L48.678,0.055L39.69,0.086C34.738,0.089 30.48,0.182 30.228,0.277ZM47.322,10.866C48.93,12.78 51.894,14.854 54.67,15.952C57.1,16.926 57.351,16.989 61.61,16.989C65.678,16.957 66.182,16.895 68.232,16.109C71.07,14.979 73.247,13.534 75.392,11.369L77.125,9.609L91.222,9.609L112.535,23.095L104.773,32.761L96.591,28.346L84.06,28.344L83.507,56.921L83.444,83.445L39.458,83.445L39.458,25.803L25.372,26.298L17.681,31.612L11.479,22.404L31.648,9.672L38.965,9.641L46.25,9.61L47.322,10.865L47.322,10.866Z",
    style: {
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/tshirt.fd37d2e7aa1392d729fa9fcd8f772b43.svg";
export { ForwardRef as ReactComponent };